import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Home } from 'lucide-react';

export default function NotFoundPage() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-lg mx-auto px-6 text-center">
          <p className="text-8xl font-bold text-[#E63946]/20 mb-4">404</p>
          <h1 className="text-3xl font-bold text-[#1D1D1F] mb-4">
            {language === 'es' ? 'Página no encontrada' : 'Page not found'}
          </h1>
          <p className="text-[#86868B] mb-8">
            {language === 'es'
              ? 'Lo sentimos, la página que buscas no existe o ha sido movida.'
              : 'Sorry, the page you are looking for does not exist or has been moved.'}
          </p>
          <div className="flex justify-center gap-4">
            <Link to="/es/" className="flex items-center gap-2 px-6 py-3 bg-[#E63946] text-white rounded-full font-medium hover:bg-[#D62828] transition-colors">
              <Home className="h-4 w-4" /> Inicio
            </Link>
            <Link to="/en/" className="flex items-center gap-2 px-6 py-3 bg-[#007AFF] text-white rounded-full font-medium hover:bg-[#0066CC] transition-colors">
              <Home className="h-4 w-4" /> Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
